module.exports = __webpack_public_path__ + "static/re_consolidated_amend_pt_405_27a_27c_new_216_text-c9aea8d51f8448bed9eaf48a90f4597c.pdf";